import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12v4h16v-4z","key":"svg-0"}],["path",{"d":"M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6","key":"svg-1"}],["path",{"d":"M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6","key":"svg-2"}]]

const IconFence = createReactComponent('outline', 'fence', 'Fence', __iconNode);

export default IconFence;